<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">

      <h2 class="outside_title d-flex">
        {{ $t('myapplication.myapplication_details.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myapplication.title')}} > </span>
            <span class="middle_loc">{{ biblio.application_no }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>

      <h3 class="oustside_sub_title">
        <v-chip>{{ applicationType }}</v-chip>
        <v-spacer class="hidden_lr8 d-inline-block"></v-spacer>
        <span>{{ biblio.application_no }}</span>
      </h3>
      <h4 class="oustside_sub_title_down_list">{{ $vuetify.rtl ? biblio.title_ar : biblio.title_en }}</h4>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data"
            hide-slider
            grow
            v-model="active_tab"
          >

            <v-tab :key="0">{{ $t('myapplication.myapplication_details.fields.biblio_data') }}</v-tab>
            <v-tab :key="1">{{ $t('myapplication.myapplication_details.fields.follow_up') }}</v-tab>
            <v-tab :key="2">{{ $t('myapplication.myapplication_details.fields.claims') }}</v-tab>
            <v-tab :key="3">{{ $t('myapplication.myapplication_details.fields.description') }}</v-tab>
            <v-tab :key="4">{{ $t('myapplication.myapplication_details.fields.drawings') }}</v-tab>
            <v-tab :key="5">{{ $t('myapplication.myapplication_details.fields.documents') }}</v-tab>
            <v-tab :key="6">{{ $t('myapplication.myapplication_details.fields.payment') }}</v-tab>
            <v-tab :key="7">{{ $t('myapplication.myapplication_details.fields.annuity') }}</v-tab>
            <v-tab :key="8">{{ $t('myapplication.myapplication_details.fields.register') }}</v-tab>



            <v-tabs-items v-model="active_tab" touchless>
              <v-tab-item :eager="true">
                <BiblioDataType1
                  v-if="type === '1'"
                  :biblio.sync="biblio"
                  :applicationType.sync="applicationType"
                />
                <BiblioDataType2
                  v-if="type === '2'"
                  :biblio.sync="biblio"
                  :applicationType.sync="applicationType"
                />
                <BiblioDataType3
                  v-if="type === '3'"
                  :biblio.sync="biblio"
                  :applicationType.sync="applicationType"
                />
              </v-tab-item>

              <v-tab-item>
                <Upcomings
                  active_type="All"
                  :seq.sync="seq"
                  :application_no="biblio.application_no"
                />
              </v-tab-item>

              <v-tab-item>
                <Claims :seq.sync="seq" />
              </v-tab-item>

              <v-tab-item>
                <Description :seq.sync="seq" />
              </v-tab-item>

              <v-tab-item>
                <Drawings :seq.sync="seq" />
              </v-tab-item>

              <v-tab-item>
                <DocumentViewer :items="documentFileList" />
              </v-tab-item>

              <v-tab-item>
                <Payment
                  :seq.sync="seq"
                  :filing_date="biblio.filing_date"
                />
              </v-tab-item>

              <v-tab-item>
                <Annuity :seq.sync="seq" />
              </v-tab-item>

              <v-tab-item>
                <Register :seq.sync="seq" />
              </v-tab-item>
            </v-tabs-items>

          </v-tabs>
        </v-flex>



      </v-layout>
      <v-layout column class="ma-0 mt-10 pos-r center__wrapper">
        <v-row class="ma-0">
          <v-col cols="12" class="d-flex pa-0">
            <v-spacer></v-spacer>
            <v-btn
              dense
              dark
              color="#acb0b3"
              min-width="150"
              min-height="50"
              class="btn-normal br_none"
              @click="fnGoList()"
            >
              {{ $t('common.button.go_to_list') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import BiblioDataType1 from './BiblioDataType1'
import BiblioDataType2 from './BiblioDataType2'
import BiblioDataType3 from './BiblioDataType3'
import Upcomings from './Upcomings'
import Register from './Register'
import Annuity from './Annuity'
import Drawings from './Drawings'
import Claims from './Claims'
import Description from './Description'
import Payment from './Payment'
import DocumentViewer from '@/components/layout/DocumentViewer'

export default {
  name : 'MyApplicationView',
  components :{
    BiblioDataType1,
    BiblioDataType2,
    BiblioDataType3,
    Upcomings,
    Register,
    Annuity,
    Drawings,
    Claims,
    Description,
    Payment,
    DocumentViewer
  },
  data () {
    return {
      id: 'MyApplicationView',
      seq : this.$route.params.seq,
      active_tab : this.$route.params.active_tab,

      type : '',
      biblio : {
        seq : null,
        receipt_date : '',
        application_no : '',
        application_receipt_no: '',
        filing_date : '',
        grant_no : '',
        grant_date : '',
        title_ar : '',
        title_en : '',
        abstract_ar : '',
        abstract_en : '',
        application_type_code : '',
        international_application_no : '',
        international_filing_date : '',
        pct_publication_no : '',
        pct_publication_date : '',
        expiration_date : '',
        first_priority_date: '',
        exhibition_name_ar : '',
        exhibition_name_en : '',
        exhibition_opening_date : '',
        exhibition_end_date : '',
        status_name_ar : '',
        status_name_en : '',
        publication_date : '',
        ind_micro_org_protection : '',
        ipas_entitlement_date: ''
      },
      applicationTypeListAr: [],
      applicationTypeListEn: [],

      documentFileList : [],

    }
  },
  computed: {
    applicationType () {
      if (this.biblio.application_type_code) {
        if (this.$vuetify.rtl) {
          return this.applicationTypeListAr.find((item)=>{
            return item.value === this.biblio.application_type_code
          }).text
        } else {
          return this.applicationTypeListEn.find((item)=>{
            return item.value === this.biblio.application_type_code
          }).text
        }
      } else {
        return ''
      }
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit(){
      let options = {
        upper_code: '8910',
        all: false
      }
      utils.fnGetCodeList(options).then(list => {
        this.applicationTypeListAr = list.ar
        this.applicationTypeListEn = list.en
        // 아래 조화에서 코드명을 사용하기 때문에
        this.fnGetMyAppDetail()
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      this.fnGetDocumentFileList()

      // 결제 결과 페이지로 들어왔을 경우
      if (this.$route.params.payment_history_seq) {
        this.active_tab = 1
      }

    },
    // 타입이 상세 API에 있기 때문에 시퀀스가 아니라 객체를 넘겨야함.
    fnGetMyAppDetail(){
      requestApi({
        url: '/applications/' + this.seq,
        method: 'GET',
        data : this.search,
        callback: (res) => {
          if (res.res_code === '200') {
            this.biblio.seq = res.data.seq
            this.biblio.receipt_date = res.data.receipt_date
            this.biblio.application_no = res.data.application_no
            this.biblio.application_receipt_no = res.data.application_receipt_no
            this.biblio.filing_date = res.data.filing_date
            this.biblio.grant_no = res.data.grant_no
            this.biblio.grant_date = res.data.grant_date
            this.biblio.title_ar = res.data.title_ar
            this.biblio.title_en = res.data.title_en
            this.biblio.abstract_ar = res.data.abstract_ar
            this.biblio.abstract_en = res.data.abstract_en
            this.biblio.application_type_code = res.data.application_type_code

            this.biblio.international_application_no = res.data.international_application_no
            this.biblio.international_filing_date = res.data.international_filing_date
            this.biblio.pct_publication_no = res.data.pct_publication_no
            this.biblio.pct_publication_date = res.data.pct_publication_date
            this.biblio.first_priority_date = res.data.first_priority_date
            this.biblio.expiration_date = res.data.expiration_date
            this.biblio.exhibition_name_ar = res.data.exhibition_name_ar
            this.biblio.exhibition_name_en = res.data.exhibition_name_en
            this.biblio.exhibition_opening_date = res.data.exhibition_opening_date
            this.biblio.exhibition_end_date = res.data.exhibition_end_date
            this.biblio.status_name_ar = res.data.status_name_ar
            this.biblio.status_name_en = res.data.status_name_en
            this.biblio.publication_date = res.data.publication_date
            this.biblio.ipas_entitlement_date = res.data.ipas_entitlement_date
            this.biblio.ind_micro_org_protection = res.data.ind_micro_org_protection

            switch (res.data.application_type_code) {
              case '8914':
                this.type = '1'  //1 Temporary
                break;
              case '8913':
                this.type = '3'  //3 IC Topography
                break;
              default:
                this.type = '2' //2
                break;
            }

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetMyAppDetail()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDocumentFileList() {
      requestApi({
        url: '/applications/' + this.seq +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoList(){
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myapplication/list?' + qryStr)
    },

  }
}
</script>